import { QueryClient, QueryClientProvider } from 'react-query'
import { useMemo } from 'react'

import { useOnErrorSnackbar } from 'hooks/useOnErrorSnackbar'

import { ReactQueryProviderProps } from './index'

export const ReactQueryProvider = ({ children }: ReactQueryProviderProps) => {
  const onErrorSnackbar = useOnErrorSnackbar()

  const queryClient = useMemo(() => {
    const onError = onErrorSnackbar
    return new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          refetchOnMount: false,
          retry: false,
          onError: err => onError(err),
        },
        mutations: {
          onError: err => onError(err),
        },
      },
    })
  }, [onErrorSnackbar])

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
